<template>
  <b-container fluid>
    <b-card
      border-variant="danger"
      :header="$t('EditCategory.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
      <div>
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab v-for="(lang, i) in langOptions" :key="i">
            <template v-slot:title>
              <country-flag :country="getLocale(lang)" size="normal" />
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <div v-for="(t, i) in form.title" :key="i">
        <b-row align-v="center" v-if="t.lang === selectedLanguage">
          <b-col col md="10">
            <b-form-group :label="$t('EditCategory.title')">
              <b-form-input :disabled="disabled.title" type="text" v-model="t.value" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col col md="2">
            <b-button
            size="sm"
            :disabled="disabled.titleSave"
            variant="danger"
            class="float-right"
            @click="editCatName()"
          >{{ $t('EditCategory.saveTitle') }}</b-button>
            <b-button
              size="sm"
              variant="secondary"
              class="float-right"
              @click="enable('title')"
            >{{ $t('EditCategory.editTitle') }}</b-button>
          </b-col>
        </b-row>
      </div>

      <b-row align-v="center">
        <b-col col md="10">
          <b-form-group :label="$t('EditCategory.parent')">
            <b-form-select
              v-model="form.parent"
              :options="parentOptions"
              :disabled="disabled.parent"
            />
          </b-form-group>
        </b-col>
        <b-col col md="2">
          <b-button
            size="sm"
            :disabled="disabled.parentSave"
            variant="danger"
            class="float-right"
            @click="addParent(form.parent, form._id)"
          >{{ $t('EditCategory.saveParent') }}</b-button>
          <b-button
            size="sm"
            variant="secondary"
            class="float-right"
            @click="enable('parent')"
          >{{ $t('EditCategory.editParent') }}</b-button>
        </b-col>
      </b-row>

      <b-row align-v="center">
        <b-col col md="10">
          <b-form-group :label="$t('EditCategory.placeNumber')">
            <b-form-input :disabled="disabled.placeNumber" type="text" v-model="form.placeNumber"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col col md="2">
          <b-button
            size="sm"
            :disabled="disabled.placeNumberSave"
            variant="danger"
            class="float-right"
            @click="setPlaceNumber"
          >{{ $t('EditCategory.savePlaceNumber') }}</b-button>
          <b-button
            size="sm"
            variant="secondary"
            class="float-right"
            @click="enable('placeNumber')"
          >{{ $t('EditCategory.editPlaceNumber') }}</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="*" sm="6">
          <b-form-group :label="$t('EditCategory.attachedSubcategories')">
            <div v-if="form.children">
              <b-list-group v-for="(c, i) in form.children" :key="i">
                <b-form-row>
                  <b-col>
                    <b-list-group-item variant="info">
                      {{filterLang(categoryObject(c))}}
                      <b-badge variant="danger" class="float-right" @click="deleteSubcategory(c)">
                        <font-awesome-icon icon="minus"/>
                      </b-badge>
                    </b-list-group-item>
                  </b-col>
                </b-form-row>
              </b-list-group>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="*" sm="6">
          <b-form-group :label="$t('EditCategory.availableSubcategories')">
            <div v-if="form.availableCategories">
              <b-list-group v-for="(c, i) in form.availableCategories" :key="i">
                <b-form-row>
                  <b-col>
                    <b-list-group-item variant="warning">
                      {{filterLang(c)}}
                      <b-badge variant="success" class="float-right" @click="addSubcategory(c)">
                        <font-awesome-icon icon="plus"/>
                      </b-badge>
                    </b-list-group-item>
                  </b-col>
                </b-form-row>
              </b-list-group>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
          <b-col>
            <b-form-group :label="$t('EditCategory.attachedItems')">
              <div v-if="form.items">
                <b-list-group  v-for="(item, i) in form.items" :key="i" >
                <b-form-row>
                  <b-col>
                    <b-list-group-item href="#" @click="toItem(item)">
                      {{filterItemName(item)}}
                    </b-list-group-item>
                  </b-col>
                </b-form-row>
              </b-list-group>
              </div>
            </b-form-group>
          </b-col>
      </b-row>

      <b-row align-v="center">
        <b-col col md="10">
          <b-form-group :label="$t('EditCategory.status')">
            <b-form-checkbox
              :disabled="disabled.hidden"
              v-model="form.hidden"
              value="true"
              unchecked-value="false"
            >{{ $t('EditCategory.hidden') }}</b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col col md="2">
          <b-button
            size="sm"
            :disabled="disabled.hiddenSave"
            variant="danger"
            class="float-right"
            @click="setCategoryStatus"
          >{{ $t('EditCategory.statusSave') }}</b-button>
          <b-button
            size="sm"
            variant="secondary"
            class="float-right"
            @click="enable('hidden')"
          >{{ $t('EditCategory.statusEdit') }}</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3 justify-content-center">
        <b-alert
          :show="error.received"
          variant="danger"
          class="text-center"
          dismissible
        >{{error.msg}}</b-alert>
      </b-row>
      <b-row class="justify-content-center">
        <router-link :to="{name: 'EditCategories'}">
          <font-awesome-icon icon="arrow-left"/>
          &nbsp;
          {{ $t('EditCategory.editCategoriesLink') }}
        </router-link>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import CategoriesService from '@/services/CategoriesService'
import locales from '../i18n/locales'
import { mapGetters } from 'vuex'

export default {
  name: 'EditCategory',
  data () {
    return {
      allCategories: [],
      disabled: {
        title: true,
        titleSave: true,
        parent: true,
        parentSave: true,
        hidden: true,
        hiddenSave: true,
        placeNumber: true,
        placeNumberSave: true
      },
      error: {
        received: false,
        msg: '',
        showLink: false
      },
      form: {
        _id: null,
        title: [],
        hidden: false,
        children: [],
        parent: null,
        items: null,
        placeNumber: null,
        availableCategories: []
      },
      initialParent: null,
      initialTitle: null,
      langOptions: [],
      parentOptions: [{ value: null, text: this.$i18n.t('EditCategory.parentDropDownText') }],
      selectedLanguage: this.$i18n.locale,
      tabIndex: 0
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(
      window.localStorage.getItem('smartdine')
    )
    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })

    // if currentCategory not in state, redirect back to EditCategories
    else if (!this.currentCategory) this.$router.push({ name: 'EditCategories' })

    // if all good, get categories and language options
    else {
      this.fetchCategories()
      this.languageOptions()
      this.selectedLanguage = this.langOptions[this.tabIndex].value
    }
  },
  methods: {
    async fetchCategories () {
      try {
        const response = await CategoriesService.getCategories()
        this.allCategories = response.data.categories

        // fetch category
        this.fetchCategory()
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
    },
    async fetchCategory () {
      // get current category
      const category = this.currentCategory

      // Prefill form
      this.form._id = category._id
      this.form.title = this.buildTitleFields(category.title)
      this.form.hidden = category.hidden
      this.form.children = category.children
      this.form.parent = category.parent
      this.form.placeNumber = category.placeNumber

      // Populate parentOptions dropdown
      if (this.form.parent) {
        // get the whole parent object
        let parentObject = this.allCategories.filter(c => {
          return c._id === this.form.parent
        })[0]
        // fill parentOptions
        this.parentOptions.push({ value: parentObject._id, text: this.filterLang(parentObject) })
      }

      // make a copy of title, parent in case user wants to change either
      this.initialTitle = category.title
      this.initialParent = category.parent

      // get category items
      try {
        // encode title in case of special URI chars
        const response = await CategoriesService.getEditCategoryItems((category._id))
        this.form.items = response.data.items
      } catch (error) {
        this.error.received = true
        if (error.response === undefined) {
          this.error.msg = this.$i18n.t('EditCategory.serverMessages.categoryNotFound')
          this.error.showLink = true
        } else {
          this.error.msg = error.response.data.error
        }
      }

      this.fetchAvailableSubcategories()
      this.fetchAvailableParents()
    },
    async fetchAvailableSubcategories () {
      // filter to exclude current category
      let filter1 = this.allCategories.filter(c => { return c._id !== this.form._id })

      // next, filter to exclude already attached subcategories
      let filter2 = []
      filter1.forEach(c => {
        if (this.form.children.includes(c._id) === false) {
          filter2.push(c)
        }
      })

      // then, proceed only if this category does not have a parent
      if (!this.form.parent) {
        // finally, filter to exclude categories with a parent and child
        filter2.forEach(c => {
          if (!c.parent && c.children.length === 0) {
            this.form.availableCategories.push(c)
          }
        })
      }
    },
    async fetchAvailableParents () {
      // filter to exclude current category
      let filter1 = this.allCategories.filter(c => { return c._id !== this.form._id })

      // next, filter to exclude already attached parent
      let filter2 = []
      filter1.forEach(c => {
        if (this.form.parent !== c._id) {
          filter2.push(c)
        }
      })

      // then, proceed only if this category does not have any children
      if (this.form.children.length === 0) {
        // finally, filter to exclude categories with a parent
        filter2.forEach(c => {
          if (!c.parent) {
            this.parentOptions.push({ value: c._id, text: this.filterLang(c) })
          }
        })
      }
    },
    async addSubcategory (subCategory) {
      // push availableSubcategory into attached subcategories
      this.form.children.push(subCategory._id)
      // take out the subcategory from availableSubcategory list
      this.form.availableCategories = this.form.availableCategories.filter(c => {
        return c._id !== subCategory._id
      })

      // build object to update category in DB
      const updateCategory = {
        _id: this.form._id,
        children: this.form.children
      }

      // update category in DB
      await CategoriesService.updateCategory(updateCategory)
      try {
        // add "parent" field to new subcateogry
        await CategoriesService.updateCategory({ _id: subCategory._id, parent: this.form._id })
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }

      // clear out parent dropdown
      this.parentOptions = [{ value: null, text: this.$i18n.t('EditCategory.parentDropDownText') }]
    },
    async deleteSubcategory (subCategoryId) {
      const updateSubcategory = {
        _id: subCategoryId,
        parent: null
      }
      try {
        // update subcategory
        const response = await CategoriesService.updateCategory(updateSubcategory)
        try {
          // then, take out subcategory from attached list
          this.form.children = this.form.children.filter(c => { return c !== subCategoryId })
          const updateCategory = {
            _id: this.form._id,
            children: this.form.children
          }
          await CategoriesService.updateCategory(updateCategory)
          try {
            // finally, put subcategory into available subcategories
            this.form.availableCategories.push(response.data.category)
          } catch (error) {
            console.log(error)
          }
        } catch (error) {
          console.log(error)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async addParent (parent, child) {
      // build object to update category in DB
      const updateCategory = {
        parent: parent,
        _id: child
      }

      try {
        // update category in DB
        await CategoriesService.updateCategory(updateCategory)

        // check if there's already a parent attached, and update its children array
        if (this.initialParent) {
          try {
          // get already attached parent
            const response = await CategoriesService.getCategory(this.initialParent)

            let filterChildren = []
            if (response.data.category.children !== null) {
              filterChildren = response.data.category.children.filter(c => { return child !== this.form._id })
            }

            try {
              // update already attached parent
              const updateCurrentParent = {
                children: filterChildren,
                _id: this.initialParent
              }
              await CategoriesService.updateCategory(updateCurrentParent)
            } catch (error) {
              console.log(error)
            }
          } catch (error) {
            console.log(error)
          }
        }

        // if not 'none', update new parent
        if (parent !== null) {
          try {
          // get parent
            const response = await CategoriesService.getCategory(parent)

            let childrenArr = response.data.category.children
            // add category to the parent's childrens array
            childrenArr.push(child)
            try {
            // finally, update parent
              const updateParent = {
                children: childrenArr,
                _id: parent
              }
              await CategoriesService.updateCategory(updateParent)

              // set this parent as "initialParent"
              this.initialParent = parent
            } catch (error) {
              console.log(error)
            }
          } catch (error) {
            console.log(error)
          }
        }
        // set dropdown & save button back to disabled
        this.disabled.parent = true
        this.disabled.parentSave = true

        // take out available subcategories unless parent is null
        if (parent === null) {
          this.fetchAvailableSubcategories()
        } else this.form.availableCategories = []
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }

      // take out available subcategories
      this.form.availableCategories = []
    },
    enable (field) {
      // make sure every field is disabled
      this.disabled.title = true
      this.disabled.titleSave = true
      this.disabled.parent = true
      this.disabled.parentSave = true
      this.disabled.hidden = true
      this.disabled.hiddenSave = true
      this.disabled.placeNumber = true
      this.disabled.placeNumberSave = true

      // enable field
      if (field === 'title') {
        this.disabled.title = false
        this.disabled.titleSave = false
      } else if (field === 'parent') {
        this.disabled.parent = false
        this.disabled.parentSave = false
      } else if (field === 'hidden') {
        this.disabled.hidden = false
        this.disabled.hiddenSave = false
      } else if (field === 'placeNumber') {
        this.disabled.placeNumber = false
        this.disabled.placeNumberSave = false
      }
    },
    async editCatName () {
      // filter out any null titles
      let title = this.form.title.filter(t => { return t.value !== null })
      const updateCategory = {
        _id: this.form._id,
        title: title
      }
      try {
        // update category in DB
        await CategoriesService.updateCategory(updateCategory)
        // disable save button and hide
        this.disabled.title = true
        this.disabled.titleSave = true
      } catch (error) {
        console.log(error)
      }
    },
    async setCategoryStatus () {
      const updateCategory = {
        _id: this.form._id,
        hidden: this.form.hidden
      }
      try {
        // update category in DB
        await CategoriesService.updateCategory(updateCategory)
        // disable save button and hide checkbox
        this.disabled.hidden = true
        this.disabled.hiddenSave = true
      } catch (error) {
        console.log(error)
      }
    },
    async setPlaceNumber () {
      const updateCategory = {
        _id: this.form._id,
        placeNumber: this.form.placeNumber
      }
      try {
        // update category in DB
        await CategoriesService.updateCategory(updateCategory)
        // disable save button and hide text field
        this.disabled.placeNumber = true
        this.disabled.placeNumberSave = true
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
    },
    toItem (item) {
      // set currentItem state
      this.$store.dispatch('setCurrentItem', item)

      // navigate to edit item panel
      this.$router.push({ name: 'EditItem', params: { item: item._id } })
    },
    languageOptions () {
      // get languages from i18n and assign value/text to langOptions
      this.langOptions = Object.keys(this.$i18n.messages).map(l => {
        return { value: l, text: l.toUpperCase() }
      })
    },
    filterLang (category) {
      // filter for selected language
      let title = category.title.filter(t => { return t.lang === this.selectedLanguage })
      // if title value undefined, filter for and assign a defined value
      return (title.length > 0) ? title[0].value : category.title.filter(t => { return t.value.length > 0 })[0].value
    },
    filterItemName (item) {
      // filter for selected language
      let locale = item.name.filter(l => { return l.lang === this.selectedLanguage })
      // if locale value undefined, filter for and assign a defined value
      return (locale.length > 0) ? locale[0].value : item.name.filter(l => { return l.value.length > 0 })[0].value
    },
    categoryObject (id) {
      return this.allCategories.filter(c => { return c._id === id })[0]
    },
    renameParentOptions () {
      // filter out the first (null) value
      let filterPOs = this.parentOptions.filter(po => { return po.value !== null })

      // get parentOptions category objects
      let poCategories = []
      filterPOs.forEach(fpo => {
        poCategories.push(this.allCategories.filter(c => { return c._id === fpo.value })[0])
      })

      // build newly named parentOptions
      let renamedPOs = [{ value: null, text: this.$i18n.t('EditCategory.parentDropDownText') }]
      poCategories.forEach(c => {
        renamedPOs.push({ value: c._id, text: this.filterLang(c) })
      })

      this.parentOptions = renamedPOs
    },
    buildTitleFields (title) {
      // this function is needed to populate title fields for all languages
      // (even if they don't exist in the category.title array)

      let titleLangs = []
      title.forEach(t => { titleLangs.push(t.lang) })

      // add title objects for all non-existing languages
      this.langOptions.forEach(l => {
        if (!titleLangs.includes(l.value)) title.push({ lang: l.value, value: null })
      })

      return title
    },
    getLocale (lang) {
      return locales.filter(l => l.code === lang.value)[0].flag
    }
  },
  computed: {
    ...mapGetters({ currentCategory: 'currentCategory' })
  },
  watch: {
    tabIndex () {
      if (this.tabIndex !== -1) {
        this.selectedLanguage = this.langOptions[this.tabIndex].value
        this.renameParentOptions()
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 0.1em 0.25em 0.1em 0.25em;
}

.modal-dialog h3 {
  color: #0d47a1;
}
.badge {
  line-height: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCategory.vue